import React, { useState } from "react";
import styles from '../Auth/input.module.css';
import '../posts/inputStyle.css';
import './../../css/table.css';
import axios from "axios";

const PWANotification = () => {

    const [title, setTitle] = useState();
    const [body, setBody] = useState();


    const SendNotification = (e) =>
    {
        e.preventDefault();
        const config = {
            headers: {
                'Authorization' : 'key=AAAAGY-8Vzw:APA91bGFtEg5szk-uzEBAJmTiWvDocFng3gO4Io_HORNRTiHXGHir8TMbWHozkLWW-zcxyWbcHGVxkyraX1QCx23IopUMYDqtFsfCW8bR75a1RgO2qbgPF0sXEemDt9dQPDMZg54TP-l',
                'Content-Type': 'application/json'
            }
        }
        axios.post('https://fcm.googleapis.com/fcm/send',{
            notification:{
                title,
                body, 
            },
            to: "/topics/all"
        }, config).then(res =>{
            console.log('res', res);
        }).catch(err =>{
            console.log(err)
        })
    };
  return (
    <div className="index">
      <form onSubmit={SendNotification}>
        <h2>ارسال پوش نوتیفیکیشن به نسخه وب</h2>
        <div className={styles.inputWrap}>
          <label className={styles.label}>
            عنوان...
          </label>
          <input
            name='title'
            type='text'
            className={styles.input}
            placeholder={'عنوان نوتیفیکیشن'}
            onChange={(e)=> setTitle(e.target.value)}
          />
        </div>

        <div className={styles.inputWrap}>
          <label className={styles.label}>
            متن...
          </label>
          <textarea
            name='body'
            type='text'
            className={styles.input}
            placeholder={'متن نوتیفیکیشن'}
            onChange={(e)=> setBody(e.target.value)}
          />
        </div>

        <div className="inputBox">
          <button
            type="submit"
            className='btn-success'
            
          >
            ارسال
          </button>
        </div>
      </form>
    </div>
  );
};

export default PWANotification;
